module.exports = __webpack_public_path__ + "static/media/robot-orange-1-up.df8dadd7.svg";